import React from 'react'

export const CoinRow = ({coin, index, darkmode}) => {
    const printValue = ( value ) => {
        if (!value) return '-';
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    
    const formatPrice = (price) => {
        if (price < 0.01) {
            return price.toFixed(6);
        } else if (price < 1) {
            return price.toFixed(4);
        } else {
            return price.toFixed(2);
        }
    }
    
    const priceChange = coin.price_change_percentage_24h || 0;
    const isPositive = priceChange > 0;
    
    return (
        <tr className={`coin-row ${darkmode ? 'dark' : ''}`}>
            <td className="rank-cell">
                <span className="rank-badge">#{coin.market_cap_rank}</span>
            </td>
            <td className="name-cell">
                <div className='coin-name-wrapper'>
                    <div className="coin-info">
                        <img 
                            src={coin.image} 
                            alt={coin.name} 
                            className='coin-image' 
                        />
                        <div className="coin-details">
                            <span className="coin-name-text">{coin.name}</span>
                            <span className='coin-symbol'>{coin.symbol.toUpperCase()}</span>
                        </div>
                    </div>
                </div>
            </td>
            <td className="price-cell">
                <span className='price-value'>
                    <span className='currency-symbol'>$</span>
                    {formatPrice(coin.current_price)}
                </span>
            </td>
            <td className={`change-cell ${isPositive ? 'positive' : 'negative'}`}>
                <span className={`change-indicator ${isPositive ? 'up' : 'down'}`}>
                    {isPositive ? '↑' : '↓'}
                </span>
                {Math.abs(Math.round(priceChange * 100) / 100)}%
            </td>
            <td className="volume-cell">
                {coin.total_volume > 0 ? `$${printValue(coin.total_volume)}` : '-'}
            </td>
            <td className="marketcap-cell">
                {coin.market_cap > 0 ? `$${printValue(coin.market_cap)}` : '-'}
            </td>
            <td className="supply-cell">
                {coin.circulating_supply > 0 ? printValue(coin.circulating_supply) : '-'}
            </td>
            <td className="max-supply-cell">
                {coin.max_supply > 0 ? printValue(coin.max_supply) : '-'}
            </td>
        </tr>
    )
}
export default CoinRow
